var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7461 16.0273C45.3008 14.2461 43.8906 12.8359 42.1836 12.3906C38.9922 11.5 26.375 11.5 26.375 11.5C26.375 11.5 13.6836 11.5 10.4922 12.3906C8.78516 12.8359 7.375 14.2461 6.92969 16.0273C6.03906 19.1445 6.03906 25.8242 6.03906 25.8242C6.03906 25.8242 6.03906 32.4297 6.92969 35.6211C7.375 37.4023 8.78516 38.7383 10.4922 39.1836C13.6836 40 26.375 40 26.375 40C26.375 40 38.9922 40 42.1836 39.1836C43.8906 38.7383 45.3008 37.4023 45.7461 35.6211C46.6367 32.4297 46.6367 25.8242 46.6367 25.8242C46.6367 25.8242 46.6367 19.1445 45.7461 16.0273ZM22.2188 31.8359V19.8125L32.7578 25.8242L22.2188 31.8359Z",
    fill: "#EB2121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -0.955176,
    y: -0.291035,
    width: 54.9104,
    height: 54.9104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.16414
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.727588
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.101961 0 0 0 0 0.466667 0 0 0 0.0337375 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.476183d2e926b0e64abcec6e63a8d1d1.svg";
export { ForwardRef as ReactComponent };